const getEnvironment = () => {
	if (typeof window === 'undefined') {
		return 'local';
	}

	const hostname = window.location.hostname;
	
	// Check for specific domains/subdomains to determine mychart/epic environment
	if (hostname.includes('osfhealthcare.org')) {
		return 'production';
	} else if (hostname.includes('osfhealthcare-uat.vercel.app')) {
		return 'uat';
	} else if (hostname.includes('osfhealthcare-dev.vercel.app')) {
		return 'dev';
	} else if (hostname.includes('osfhealthcare-staging.vercel.app')) {
		return 'staging';
	} else {
		return 'local';
	}
};

const myChartConfig = {
	production: {
		existingPatientSchedulingUrl: 'https://osfmychart.org/OSFMyChart/scheduling',
		openSchedulingBaseIframeSrc: 'https://www.osfmychart.org/osfmychart/openscheduling/embedded',
		onMyWayBaseIframeSrc: 'https://www.osfmychart.org/OSFMyChart/Scheduling/OnMyWay/widget',
		epicApi: 'https://ssproxy.osfhealthcare.org/dxp/',
    getScheduleDays:'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		epicClientID: 'b2155cc7-b75b-4b90-9f3b-f43ade2b3336',
		epicAccessToken: 'ZW1wJE9TRkRYUFBSRDpSZWoyITdqOVZ3NUg=',
		apiKey: 'WawdpDIoHdXatMX',
		host: 'osfmychart.org',
		instance: 'osfmychart'
	},
	staging: {
		existingPatientSchedulingUrl: 'https://pmc-pia-apsg.intranet.osfnet.org/scheduling',
		openSchedulingBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/openscheduling/embedded',
		onMyWayBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/scheduling/onmyway/widget',
		epicApi: 'https://ssproxy-test.osfhealthcare.org/DXP-TST/',
    getScheduleDays:'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		epicClientID: '13e07965-55a3-4f1f-a19e-45be7a82f8a7',
		epicAccessToken: 'ZW1wJE9TRkRYUE5PTlBSRDpQa2RsYTgzXkRhcjQ=',
		apiKey: 'dEbnSWYxCIbUlBh',
		host: 'pmc-pia-apsg.intranet.osfnet.org',
		instance: 'osfmychart'
	},
	dev: {
		existingPatientSchedulingUrl: 'https://pmc-pia-apsg.intranet.osfnet.org/scheduling',
		openSchedulingBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/openscheduling/embedded',
		onMyWayBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/scheduling/onmyway/widget',
		epicApi: 'https://ssproxy-test.osfhealthcare.org/DXP-TST/',
    getScheduleDays:'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		epicClientID: '13e07965-55a3-4f1f-a19e-45be7a82f8a7',
		epicAccessToken: 'ZW1wJE9TRkRYUE5PTlBSRDpQa2RsYTgzXkRhcjQ=',
		apiKey: 'TcnsIqsM2139856',
		host: 'pmc-pia-apsg.intranet.osfnet.org',
		instance: 'osfmychart'
	},
	uat: {
		existingPatientSchedulingUrl: 'https://pmc-pia-apsg.intranet.osfnet.org/scheduling',
		openSchedulingBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/openscheduling/embedded',
		onMyWayBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/scheduling/onmyway/widget',
		epicApi: 'https://ssproxy-test.osfhealthcare.org/DXP-TST/',
    getScheduleDays:'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		epicClientID: '13e07965-55a3-4f1f-a19e-45be7a82f8a7',
		epicAccessToken: 'ZW1wJE9TRkRYUE5PTlBSRDpQa2RsYTgzXkRhcjQ=',
		apiKey: 'lWWZrwF36503537',
		host: 'pmc-pia-apsg.intranet.osfnet.org',
		instance: 'osfmychart'
	},
	local: {
		existingPatientSchedulingUrl: 'https://pmc-pia-apsg.intranet.osfnet.org/OSFMyChart/Scheduling',
		openSchedulingBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/openscheduling/embedded',
		onMyWayBaseIframeSrc: 'https://pmc-pia-apsg.intranet.osfnet.org/osfmychart/scheduling/onmyway/widget',
		epicApi: 'https://ssproxy-test.osfhealthcare.org/DXP-TST',
    getScheduleDays:'api/epic/2017/PatientAccess/External/GetScheduleDaysForProvider2/Scheduling/Open/Provider/GetScheduleDays2',
		epicClientID: '13e07965-55a3-4f1f-a19e-45be7a82f8a7',
		epicAccessToken: 'ZW1wJE9TRkRYUE5PTlBSRDpQa2RsYTgzXkRhcjQ=',
		apiKey: 'goBdua888686880',
		host: 'pmc-pia-apsg.intranet.osfnet.org',
		instance: 'osfmychart'
	}
};

const currentEnvironment = getEnvironment();
const myChart = myChartConfig[currentEnvironment];

export { getEnvironment, myChartConfig, currentEnvironment, myChart };